module.exports = __webpack_public_path__ + "static/media/email.42fb322e.svg";